<script lang="ts">
  import {onMount} from 'svelte'
  import api from '../api/api'
  import {t} from '../i18n'
  import {inGroupsOf} from '../utils/array'
  import type {Tag} from '../types'

  let popularTags: Tag[] = []
  let weekPopularTags: Tag[] = []

  onMount(async () => {
    popularTags = await api.get<Tag[]>('/tags/popular?per=39')
    weekPopularTags = await api.get<Tag[]>('/tags/week_popular?per=15')
  })

  const tagUrl = (tag: { name: string }) => `/explore?tags=${encodeURIComponent(tag.name)}`
</script>

<div class="row">
  <div class="grid-section tags-wrap clearfix">
    <div class="heading with-filter inner-heading">
      <h2>
        {t.tags.index.title}
      </h2>
    </div>
    <div class="sidetags">
      <h3>{t.tags.index.week_popular_tags}</h3>
      <ul class="tag-list">
        {#each weekPopularTags as tag}
          <li>
            <a href={tagUrl(tag)}>
              {tag.name}
              <span>{tag.poems_count}</span>
            </a>
          </li>
        {/each}
      </ul>
    </div>
    <div class="main-tags">
      <div class="grid three">
        {#each inGroupsOf(popularTags, 13) as tagGroup}
          <div class="grid__item">
            <ul class="tag-list">
              {#each tagGroup as tag}
                <li>
                  <a href={tagUrl(tag)}>
                    {tag.name}
                    <span>{tag.poems_count}</span>
                  </a>
                </li>
              {/each}
            </ul>
          </div>
        {/each}
      </div>
    </div>
  </div>
</div>
